// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_wrk_ctx = require("./MM_wrk_ctx.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Belt_MutableMap = require("rescript/lib/js/belt_MutableMap.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Belt_MutableSetString = require("rescript/lib/js/belt_MutableSetString.js");

function contIsEmpty(cont) {
  if (cont.TAG === /* Text */0) {
    return cont._0.length === 0;
  } else {
    return MM_syntax_tree.syntaxTreeIsEmpty(cont._0);
  }
}

function contToArrStr(cont) {
  if (cont.TAG === /* Text */0) {
    return cont._0;
  } else {
    return MM_syntax_tree.syntaxTreeToSymbols(cont._0);
  }
}

function contToStr(cont) {
  return contToArrStr(cont).join(" ");
}

function strToCont(str) {
  return {
          TAG: /* Text */0,
          _0: MM_parser.getSpaceSeparatedValuesAsArray(str)
        };
}

function userStmtTypeFromStr(str) {
  switch (str) {
    case "e" :
        return "e";
    case "p" :
        return "p";
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to userStmtType"
            },
            Error: new Error()
          };
  }
}

function createEmptyUserStmt(id, typ, label) {
  return {
          id: id,
          label: label,
          labelEditMode: false,
          typ: typ,
          typEditMode: false,
          cont: {
            TAG: /* Text */0,
            _0: []
          },
          contEditMode: true,
          jstfText: "",
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proof: undefined,
          proofStatus: undefined
        };
}

function updateStmt(st, id, update) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts.map(function (stmt) {
                if (stmt.id === id) {
                  return Curry._1(update, stmt);
                } else {
                  return stmt;
                }
              }),
          checkedStmtIds: st.checkedStmtIds
        };
}

function isStmtChecked(st, id) {
  return st.checkedStmtIds.includes(id);
}

function toggleStmtChecked(st, id) {
  if (st.checkedStmtIds.includes(id)) {
    return {
            settingsV: st.settingsV,
            settings: st.settings,
            preCtxV: st.preCtxV,
            preCtx: st.preCtx,
            frms: st.frms,
            varsText: st.varsText,
            varsEditMode: st.varsEditMode,
            varsErr: st.varsErr,
            disjText: st.disjText,
            disjEditMode: st.disjEditMode,
            disjErr: st.disjErr,
            disj: st.disj,
            wrkCtx: st.wrkCtx,
            nextStmtId: st.nextStmtId,
            stmts: st.stmts,
            checkedStmtIds: st.checkedStmtIds.filter(function (checkedId) {
                  return checkedId !== id;
                })
          };
  } else {
    return {
            settingsV: st.settingsV,
            settings: st.settings,
            preCtxV: st.preCtxV,
            preCtx: st.preCtx,
            frms: st.frms,
            varsText: st.varsText,
            varsEditMode: st.varsEditMode,
            varsErr: st.varsErr,
            disjText: st.disjText,
            disjEditMode: st.disjEditMode,
            disjErr: st.disjErr,
            disj: st.disj,
            wrkCtx: st.wrkCtx,
            nextStmtId: st.nextStmtId,
            stmts: st.stmts,
            checkedStmtIds: st.checkedStmtIds.concat([id])
          };
  }
}

function checkAllStmts(st) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.stmts.map(function (stmt) {
                return stmt.id;
              })
        };
}

function uncheckAllStmts(st) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: []
        };
}

function deleteCheckedStmts(st) {
  var newStmts = st.stmts.filter(function (stmt) {
        return !st.checkedStmtIds.includes(stmt.id);
      });
  var newNextStmtId = newStmts.length === 0 ? 0 : st.nextStmtId;
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: newNextStmtId,
          stmts: newStmts,
          checkedStmtIds: []
        };
}

function canMoveCheckedStmts(st, up) {
  var len = st.stmts.length;
  if (len !== 0 && st.checkedStmtIds.length !== 0) {
    if (up && !st.checkedStmtIds.includes(Caml_array.get(st.stmts, 0).id)) {
      return true;
    } else if (up) {
      return false;
    } else {
      return !st.checkedStmtIds.includes(Caml_array.get(st.stmts, len - 1 | 0).id);
    }
  } else {
    return false;
  }
}

function moveCheckedStmts(st, up) {
  if (!canMoveCheckedStmts(st, up)) {
    return st;
  }
  var len = st.stmts.length;
  var res = st.stmts.slice();
  if (up) {
    var maxI = len - 2 | 0;
    for(var i = 0; i <= maxI; ++i){
      if (!st.checkedStmtIds.includes(Caml_array.get(res, i).id) && st.checkedStmtIds.includes(Caml_array.get(res, i + 1 | 0).id)) {
        var tmp = Caml_array.get(res, i);
        Caml_array.set(res, i, Caml_array.get(res, i + 1 | 0));
        Caml_array.set(res, i + 1 | 0, tmp);
      }
      
    }
  } else {
    for(var i$1 = len - 1 | 0; i$1 >= 1; --i$1){
      if (st.checkedStmtIds.includes(Caml_array.get(res, i$1 - 1 | 0).id) && !st.checkedStmtIds.includes(Caml_array.get(res, i$1).id)) {
        var tmp$1 = Caml_array.get(res, i$1);
        Caml_array.set(res, i$1, Caml_array.get(res, i$1 - 1 | 0));
        Caml_array.set(res, i$1 - 1 | 0, tmp$1);
      }
      
    }
  }
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: res,
          checkedStmtIds: st.checkedStmtIds
        };
}

function createNewLabel(st, prefix) {
  var isLabelDefinedInCtx = function (label) {
    var wrkCtx = st.wrkCtx;
    if (wrkCtx === undefined) {
      return false;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    if (MM_context.isHyp(wrkCtx$1, label)) {
      return true;
    } else {
      return MM_context.isAsrt(wrkCtx$1, label);
    }
  };
  var usedLabels = st.stmts.map(function (stmt) {
        return stmt.label;
      });
  var i = 1;
  var newLabel = prefix + String(i);
  while(usedLabels.includes(newLabel) || isLabelDefinedInCtx(newLabel)) {
    i = i + 1 | 0;
    newLabel = prefix + String(i);
  };
  return newLabel;
}

function addNewStmt(st) {
  var newId = String(st.nextStmtId);
  var newLabel = createNewLabel(st, "stmt");
  var idToAddBefore = Belt_Option.map(Caml_option.undefined_to_opt(st.stmts.find(function (stmt) {
                return st.checkedStmtIds.includes(stmt.id);
              })), (function (stmt) {
          return stmt.id;
        }));
  return [
          {
            settingsV: st.settingsV,
            settings: st.settings,
            preCtxV: st.preCtxV,
            preCtx: st.preCtx,
            frms: st.frms,
            varsText: st.varsText,
            varsEditMode: st.varsEditMode,
            varsErr: st.varsErr,
            disjText: st.disjText,
            disjEditMode: st.disjEditMode,
            disjErr: st.disjErr,
            disj: st.disj,
            wrkCtx: st.wrkCtx,
            nextStmtId: st.nextStmtId + 1 | 0,
            stmts: idToAddBefore !== undefined ? Belt_Array.concatMany(st.stmts.map(function (stmt) {
                        if (stmt.id === idToAddBefore) {
                          return [
                                  createEmptyUserStmt(newId, "p", newLabel),
                                  stmt
                                ];
                        } else {
                          return [stmt];
                        }
                      })) : st.stmts.concat([createEmptyUserStmt(newId, "p", newLabel)]),
            checkedStmtIds: st.checkedStmtIds
          },
          newId
        ];
}

function isSingleStmtChecked(st) {
  return st.checkedStmtIds.length === 1;
}

function duplicateCheckedStmt(st) {
  if (!isSingleStmtChecked(st)) {
    return st;
  }
  var newId = String(st.nextStmtId);
  var newLabel = createNewLabel(st, "stmt");
  var idToAddAfter = Caml_array.get(st.checkedStmtIds, 0);
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId + 1 | 0,
          stmts: Belt_Array.concatMany(st.stmts.map(function (stmt) {
                    if (stmt.id === idToAddAfter) {
                      return [
                              stmt,
                              {
                                id: newId,
                                label: newLabel,
                                labelEditMode: stmt.labelEditMode,
                                typ: stmt.typ,
                                typEditMode: stmt.typEditMode,
                                cont: stmt.cont,
                                contEditMode: stmt.contEditMode,
                                jstfText: "",
                                jstfEditMode: stmt.jstfEditMode,
                                stmtErr: stmt.stmtErr,
                                expr: stmt.expr,
                                jstf: stmt.jstf,
                                proof: stmt.proof,
                                proofStatus: stmt.proofStatus
                              }
                            ];
                    } else {
                      return [stmt];
                    }
                  })),
          checkedStmtIds: [newId]
        };
}

function canGoEditModeForStmt(st, stmtId) {
  return !st.stmts.some(function (stmt) {
              if (stmt.id === stmtId) {
                if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
                  return true;
                } else {
                  return stmt.jstfEditMode;
                }
              } else {
                return false;
              }
            });
}

function setVarsEditMode(st) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: true,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function completeVarsEditMode(st, newVarsText) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: newVarsText,
          varsEditMode: false,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function setDisjEditMode(st) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: true,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function completeDisjEditMode(st, newDisjText) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: newDisjText,
          disjEditMode: false,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function setLabelEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: true,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeLabelEditMode(st, stmtId, newLabel) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newLabel.trim() !== "") {
                  return {
                          id: stmt.id,
                          label: newLabel,
                          labelEditMode: false,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                } else {
                  return stmt;
                }
              }));
}

function setContEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: true,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeContEditMode(st, stmtId, newCont) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (contIsEmpty(newCont)) {
                  return stmt;
                } else {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: newCont,
                          contEditMode: false,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }
              }));
}

function setTypEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: true,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeTypEditMode(st, stmtId, newTyp) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: newTyp,
                        typEditMode: false,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: stmt.jstfText,
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus
                      };
              }));
}

function setJstfEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: true,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  } else {
    return st;
  }
}

function completeJstfEditMode(st, stmtId, newJstf) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: newJstf,
                        jstfEditMode: false,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus
                      };
              }));
}

function setSettings(st, settingsV, settings) {
  return {
          settingsV: settingsV,
          settings: settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function setPreCtx(st, preCtxV, preCtx) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: preCtxV,
          preCtx: preCtx,
          frms: MM_substitution.prepareFrmSubsData(preCtx),
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function sortStmtsByType(st) {
  var stmtToInt = function (stmt) {
    var match = stmt.typ;
    if (match === "p") {
      return 2;
    } else {
      return 1;
    }
  };
  var comp = function (a, b) {
    return stmtToInt(a) - stmtToInt(b) | 0;
  };
  var stmtsLen = st.stmts.length;
  if (stmtsLen < 2) {
    return st;
  }
  var newStmts = st.stmts.slice();
  var changed = true;
  var e = stmtsLen - 2 | 0;
  while(e >= 0 && changed) {
    changed = false;
    for(var i = 0; i <= e; ++i){
      if (Curry._2(comp, Caml_array.get(newStmts, i), Caml_array.get(newStmts, i + 1 | 0)) > 0) {
        var tmp = Caml_array.get(newStmts, i);
        Caml_array.set(newStmts, i, Caml_array.get(newStmts, i + 1 | 0));
        Caml_array.set(newStmts, i + 1 | 0, tmp);
        changed = true;
      }
      
    }
    e = e - 1 | 0;
  };
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: newStmts,
          checkedStmtIds: st.checkedStmtIds
        };
}

function removeAllErrorsInUserStmt(stmt) {
  return {
          id: stmt.id,
          label: stmt.label,
          labelEditMode: stmt.labelEditMode,
          typ: stmt.typ,
          typEditMode: stmt.typEditMode,
          cont: stmt.cont,
          contEditMode: stmt.contEditMode,
          jstfText: stmt.jstfText,
          jstfEditMode: stmt.jstfEditMode,
          stmtErr: undefined,
          expr: stmt.expr,
          jstf: stmt.jstf,
          proof: stmt.proof,
          proofStatus: stmt.proofStatus
        };
}

function removeAllErrorsInEditorState(st) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: undefined,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: undefined,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts.map(removeAllErrorsInUserStmt),
          checkedStmtIds: st.checkedStmtIds
        };
}

function removeAllProofData(st) {
  return {
          settingsV: st.settingsV,
          settings: st.settings,
          preCtxV: st.preCtxV,
          preCtx: st.preCtx,
          frms: st.frms,
          varsText: st.varsText,
          varsEditMode: st.varsEditMode,
          varsErr: st.varsErr,
          disjText: st.disjText,
          disjEditMode: st.disjEditMode,
          disjErr: st.disjErr,
          disj: st.disj,
          wrkCtx: st.wrkCtx,
          nextStmtId: st.nextStmtId,
          stmts: st.stmts.map(function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: stmt.jstfText,
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: undefined,
                        jstf: undefined,
                        proof: undefined,
                        proofStatus: undefined
                      };
              }),
          checkedStmtIds: st.checkedStmtIds
        };
}

function userStmtHasErrors(stmt) {
  return Belt_Option.isSome(stmt.stmtErr);
}

function editorStateHasErrors(st) {
  if (Belt_Option.isSome(st.varsErr) || Belt_Option.isSome(st.disjErr)) {
    return true;
  } else {
    return st.stmts.some(userStmtHasErrors);
  }
}

function refreshWrkCtx(st) {
  var st$1 = sortStmtsByType(st);
  var st$2 = removeAllErrorsInEditorState(st$1);
  var wrkCtxRes = MM_wrk_ctx.createWrkCtx(st$2.preCtx, st$2.varsText, st$2.disjText, st$2.stmts.filter(function (stmt) {
              return stmt.typ === "e";
            }).map(function (stmt) {
            return {
                    id: stmt.id,
                    label: stmt.label,
                    text: contToArrStr(stmt.cont).join(" ")
                  };
          }));
  if (wrkCtxRes.TAG !== /* Ok */0) {
    var wrkCtxErr = wrkCtxRes._0;
    var msg = wrkCtxErr.varsErr;
    var st$3 = msg !== undefined ? ({
          settingsV: st$2.settingsV,
          settings: st$2.settings,
          preCtxV: st$2.preCtxV,
          preCtx: st$2.preCtx,
          frms: st$2.frms,
          varsText: st$2.varsText,
          varsEditMode: st$2.varsEditMode,
          varsErr: msg,
          disjText: st$2.disjText,
          disjEditMode: st$2.disjEditMode,
          disjErr: st$2.disjErr,
          disj: st$2.disj,
          wrkCtx: st$2.wrkCtx,
          nextStmtId: st$2.nextStmtId,
          stmts: st$2.stmts,
          checkedStmtIds: st$2.checkedStmtIds
        }) : st$2;
    var msg$1 = wrkCtxErr.disjErr;
    var st$4 = msg$1 !== undefined ? ({
          settingsV: st$3.settingsV,
          settings: st$3.settings,
          preCtxV: st$3.preCtxV,
          preCtx: st$3.preCtx,
          frms: st$3.frms,
          varsText: st$3.varsText,
          varsEditMode: st$3.varsEditMode,
          varsErr: st$3.varsErr,
          disjText: st$3.disjText,
          disjEditMode: st$3.disjEditMode,
          disjErr: msg$1,
          disj: st$3.disj,
          wrkCtx: st$3.wrkCtx,
          nextStmtId: st$3.nextStmtId,
          stmts: st$3.stmts,
          checkedStmtIds: st$3.checkedStmtIds
        }) : st$3;
    var match = wrkCtxErr.hypErr;
    if (match === undefined) {
      return st$4;
    }
    var msg$2 = match[1];
    return updateStmt(st$4, match[0], (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: msg$2,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }));
  }
  var wrkCtx = wrkCtxRes._0;
  var st_settingsV = st$2.settingsV;
  var st_settings = st$2.settings;
  var st_preCtxV = st$2.preCtxV;
  var st_preCtx = st$2.preCtx;
  var st_frms = st$2.frms;
  var st_varsText = st$2.varsText;
  var st_varsEditMode = st$2.varsEditMode;
  var st_varsErr = st$2.varsErr;
  var st_disjText = st$2.disjText;
  var st_disjEditMode = st$2.disjEditMode;
  var st_disjErr = st$2.disjErr;
  var st_disj = st$2.disj;
  var st_wrkCtx = Caml_option.some(wrkCtx);
  var st_nextStmtId = st$2.nextStmtId;
  var st_stmts = st$2.stmts;
  var st_checkedStmtIds = st$2.checkedStmtIds;
  var st$5 = {
    settingsV: st_settingsV,
    settings: st_settings,
    preCtxV: st_preCtxV,
    preCtx: st_preCtx,
    frms: st_frms,
    varsText: st_varsText,
    varsEditMode: st_varsEditMode,
    varsErr: st_varsErr,
    disjText: st_disjText,
    disjEditMode: st_disjEditMode,
    disjErr: st_disjErr,
    disj: st_disj,
    wrkCtx: st_wrkCtx,
    nextStmtId: st_nextStmtId,
    stmts: st_stmts,
    checkedStmtIds: st_checkedStmtIds
  };
  return st_stmts.reduce((function (st, stmt) {
                if (stmt.typ === "e") {
                  return updateStmt(st, stmt.id, (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        labelEditMode: stmt.labelEditMode,
                                        typ: stmt.typ,
                                        typEditMode: stmt.typEditMode,
                                        cont: stmt.cont,
                                        contEditMode: stmt.contEditMode,
                                        jstfText: stmt.jstfText,
                                        jstfEditMode: stmt.jstfEditMode,
                                        stmtErr: stmt.stmtErr,
                                        expr: MM_context.ctxSymsToIntsExn(wrkCtx, contToArrStr(stmt.cont)),
                                        jstf: stmt.jstf,
                                        proof: stmt.proof,
                                        proofStatus: stmt.proofStatus
                                      };
                              }));
                } else {
                  return st;
                }
              }), st$5);
}

function parseJstf(jstfText) {
  var jstfTrim = jstfText.trim();
  if (jstfTrim.length === 0) {
    return ;
  }
  var argsAndAsrt = jstfTrim.split(":");
  if (argsAndAsrt.length !== 2) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot parse justification: '" + jstfText + "' [1]."
          },
          Error: new Error()
        };
  }
  return {
          args: MM_parser.getSpaceSeparatedValuesAsArray(Caml_array.get(argsAndAsrt, 0)),
          asrt: Caml_array.get(argsAndAsrt, 1).trim()
        };
}

function setExprAndJstf(stmt, wrkCtx) {
  if (Belt_Option.isSome(stmt.stmtErr)) {
    return stmt;
  }
  try {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: MM_context.ctxSymsToIntsExn(wrkCtx, contToArrStr(stmt.cont)),
            jstf: parseJstf(stmt.jstfText),
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === MM_parser.MmException) {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: stmt.cont,
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: exn._1.msg,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proof: stmt.proof,
              proofStatus: stmt.proofStatus
            };
    }
    throw exn;
  }
}

function isLabelDefined(label, wrkCtx, usedLabels) {
  if (Belt_MutableSetString.has(usedLabels, label) || MM_context.isHyp(wrkCtx, label)) {
    return true;
  } else {
    return MM_context.isAsrt(wrkCtx, label);
  }
}

function validateJstfRefs(stmt, wrkCtx, usedLabels) {
  if (Belt_Option.isSome(stmt.stmtErr)) {
    return stmt;
  }
  var match = stmt.jstf;
  if (match === undefined) {
    return stmt;
  }
  var asrt = match.asrt;
  var ref = match.args.find(function (ref) {
        return !isLabelDefined(ref, wrkCtx, usedLabels);
      });
  if (ref !== undefined) {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: "The reference '" + ref + "' is not defined.",
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  } else if (MM_context.isAsrt(wrkCtx, asrt)) {
    return stmt;
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: "The label '" + asrt + "' doesn't refer to any assertion.",
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  }
}

function validateStmtLabel(stmt, wrkCtx, usedLabels) {
  if (Belt_Option.isSome(stmt.stmtErr) || !isLabelDefined(stmt.label, wrkCtx, usedLabels)) {
    return stmt;
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: "Cannot reuse label '" + stmt.label + "'.",
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus
          };
  }
}

function checkAllStmtsAreUnique(st) {
  var declaredStmts = Belt_MutableMap.make(MM_context.ExprCmp);
  return st.stmts.reduce((function (st, stmt) {
                if (editorStateHasErrors(st)) {
                  return st;
                }
                var expr = stmt.expr;
                var stmt$1;
                if (expr !== undefined) {
                  var prevStmtLabel = Belt_MutableMap.get(declaredStmts, expr);
                  if (prevStmtLabel !== undefined) {
                    stmt$1 = {
                      id: stmt.id,
                      label: stmt.label,
                      labelEditMode: stmt.labelEditMode,
                      typ: stmt.typ,
                      typEditMode: stmt.typEditMode,
                      cont: stmt.cont,
                      contEditMode: stmt.contEditMode,
                      jstfText: stmt.jstfText,
                      jstfEditMode: stmt.jstfEditMode,
                      stmtErr: "This statement is the same as the previous one - '" + prevStmtLabel + "'",
                      expr: stmt.expr,
                      jstf: stmt.jstf,
                      proof: stmt.proof,
                      proofStatus: stmt.proofStatus
                    };
                  } else {
                    Belt_MutableMap.set(declaredStmts, expr, stmt.label);
                    stmt$1 = stmt;
                  }
                } else {
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "Cannot checkAllStmtsAreUnique without expr."
                        },
                        Error: new Error()
                      };
                }
                return updateStmt(st, stmt$1.id, (function (param) {
                              return stmt$1;
                            }));
              }), st);
}

function prepareProvablesForUnification(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var usedLabels = Belt_MutableSetString.make(undefined);
    return st.stmts.reduce((function (st, stmt) {
                  if (editorStateHasErrors(st) || stmt.typ !== "p") {
                    return st;
                  }
                  var stmt$1 = setExprAndJstf(stmt, wrkCtx$1);
                  var stmt$2 = validateJstfRefs(stmt$1, wrkCtx$1, usedLabels);
                  var stmt$3 = validateStmtLabel(stmt$2, wrkCtx$1, usedLabels);
                  Belt_MutableSetString.add(usedLabels, stmt$3.label);
                  return updateStmt(st, stmt$3.id, (function (param) {
                                return stmt$3;
                              }));
                }), st);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot prepareProvablesForUnification without wrkCtx."
        },
        Error: new Error()
      };
}

function prepareEditorForUnification(st) {
  var st$1 = removeAllErrorsInEditorState(st);
  return [
            removeAllProofData,
            refreshWrkCtx,
            prepareProvablesForUnification,
            checkAllStmtsAreUnique
          ].reduce((function (st, act) {
                if (editorStateHasErrors(st)) {
                  return st;
                } else {
                  return Curry._1(act, st);
                }
              }), st$1);
}

function createNewVars(st, varTypes) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var numOfVars = varTypes.length;
    if (numOfVars === 0) {
      return [
              st,
              []
            ];
    }
    var newVarNames = MM_context.generateNewVarNames(wrkCtx$1, varTypes);
    var newHypLabels = MM_context.generateNewLabels(wrkCtx$1, "var", numOfVars);
    MM_context.applySingleStmt(wrkCtx$1, {
          TAG: /* Var */3,
          symbols: newVarNames
        });
    var varTypeNames = MM_context.ctxIntsToSymsExn(wrkCtx$1, varTypes);
    newHypLabels.forEach(function (label, i) {
          MM_context.applySingleStmt(wrkCtx$1, {
                TAG: /* Floating */5,
                label: label,
                expr: [
                  Caml_array.get(varTypeNames, i),
                  Caml_array.get(newVarNames, i)
                ]
              });
        });
    var newVarInts = MM_context.ctxSymsToIntsExn(wrkCtx$1, newVarNames);
    var newVarsText = newHypLabels.map(function (label, i) {
            return "" + label + " " + Caml_array.get(varTypeNames, i) + " " + Caml_array.get(newVarNames, i) + "";
          }).join("\n");
    return [
            {
              settingsV: st.settingsV,
              settings: st.settings,
              preCtxV: st.preCtxV,
              preCtx: st.preCtx,
              frms: st.frms,
              varsText: st.varsText + (
                st.varsText.length !== 0 ? "\n" : ""
              ) + newVarsText,
              varsEditMode: st.varsEditMode,
              varsErr: st.varsErr,
              disjText: st.disjText,
              disjEditMode: st.disjEditMode,
              disjErr: st.disjErr,
              disj: st.disj,
              wrkCtx: st.wrkCtx,
              nextStmtId: st.nextStmtId,
              stmts: st.stmts,
              checkedStmtIds: st.checkedStmtIds
            },
            newVarInts
          ];
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot create new variables without wrkCtx."
        },
        Error: new Error()
      };
}

function createNewDisj(st, newDisj) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            MM_context.applySingleStmt(wrkCtx$1, {
                  TAG: /* Disj */4,
                  vars: MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts)
                });
          }));
    var newDisjTextLines = [];
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            newDisjTextLines.push(MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts));
          }));
    if (newDisjTextLines.length === 0) {
      return st;
    }
    var newDisjText = newDisjTextLines.join("\n");
    return {
            settingsV: st.settingsV,
            settings: st.settings,
            preCtxV: st.preCtxV,
            preCtx: st.preCtx,
            frms: st.frms,
            varsText: st.varsText,
            varsEditMode: st.varsEditMode,
            varsErr: st.varsErr,
            disjText: st.disjText + "\n" + newDisjText,
            disjEditMode: st.disjEditMode,
            disjErr: st.disjErr,
            disj: st.disj,
            wrkCtx: st.wrkCtx,
            nextStmtId: st.nextStmtId,
            stmts: st.stmts,
            checkedStmtIds: st.checkedStmtIds
          };
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot create new disjoints without wrkCtx."
        },
        Error: new Error()
      };
}

function addAsrtSearchResult(st, applRes) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var frm = Belt_MapString.get(st.frms, applRes.asrtLabel);
    if (frm !== undefined) {
      var match = createNewVars(st, applRes.newVarTypes);
      var newCtxVarInts = match[1];
      var applResVarToCtxVar = Belt_MutableMapInt.make(undefined);
      applRes.newVars.forEach(function (applResVarInt, i) {
            Belt_MutableMapInt.set(applResVarToCtxVar, applResVarInt, Caml_array.get(newCtxVarInts, i));
          });
      var newCtxDisj = MM_context.disjMutableMake(undefined);
      MM_context.disjForEach(applRes.newDisj, (function (n, m) {
              var newN = Belt_MutableMapInt.get(applResVarToCtxVar, n);
              var newN$1 = newN !== undefined ? newN : n;
              var newM = Belt_MutableMapInt.get(applResVarToCtxVar, m);
              var newM$1 = newM !== undefined ? newM : m;
              MM_context.disjAddPair(newCtxDisj, newN$1, newM$1);
            }));
      var st$1 = createNewDisj(match[0], newCtxDisj);
      var selectionWasEmpty = st$1.checkedStmtIds.length === 0;
      var st$2 = !selectionWasEmpty || st$1.stmts.length === 0 ? st$1 : toggleStmtChecked(st$1, Caml_array.get(st$1.stmts, 0).id);
      var mainStmtLabel = createNewLabel(st$2, "stmt");
      var argLabels = [];
      var stMut = {
        contents: st$2
      };
      frm.frame.hyps.forEach(function (hyp) {
            if (hyp.typ !== /* E */1) {
              return ;
            }
            var argLabel = createNewLabel(stMut.contents, mainStmtLabel + "-" + hyp.label);
            argLabels.push(argLabel);
            var argExprText = MM_context.ctxIntsToStrExn(wrkCtx$1, MM_substitution.applySubs(hyp.expr, applRes.subs, (function (param) {
                          throw {
                                RE_EXN_ID: MM_parser.MmException,
                                _1: {
                                  msg: "Cannot create a work variable in addAsrtSearchResult [1]."
                                },
                                Error: new Error()
                              };
                        })).map(function (appResInt) {
                      var ctxVar = Belt_MutableMapInt.get(applResVarToCtxVar, appResInt);
                      if (ctxVar !== undefined) {
                        return ctxVar;
                      } else {
                        return appResInt;
                      }
                    }));
            var match = addNewStmt(stMut.contents);
            stMut.contents = match[0];
            stMut.contents = updateStmt(stMut.contents, match[1], (function (stmt) {
                    return {
                            id: stmt.id,
                            label: argLabel,
                            labelEditMode: stmt.labelEditMode,
                            typ: "p",
                            typEditMode: stmt.typEditMode,
                            cont: {
                              TAG: /* Text */0,
                              _0: MM_parser.getSpaceSeparatedValuesAsArray(argExprText)
                            },
                            contEditMode: false,
                            jstfText: stmt.jstfText,
                            jstfEditMode: stmt.jstfEditMode,
                            stmtErr: stmt.stmtErr,
                            expr: stmt.expr,
                            jstf: stmt.jstf,
                            proof: stmt.proof,
                            proofStatus: stmt.proofStatus
                          };
                  }));
          });
      var st$3 = stMut.contents;
      var asrtExprText = MM_context.ctxIntsToStrExn(wrkCtx$1, MM_substitution.applySubs(frm.frame.asrt, applRes.subs, (function (param) {
                    throw {
                          RE_EXN_ID: MM_parser.MmException,
                          _1: {
                            msg: "Cannot create a work variable in addAsrtSearchResult [2]."
                          },
                          Error: new Error()
                        };
                  })).map(function (appResInt) {
                var ctxVar = Belt_MutableMapInt.get(applResVarToCtxVar, appResInt);
                if (ctxVar !== undefined) {
                  return ctxVar;
                } else {
                  return appResInt;
                }
              }));
      var match$1 = addNewStmt(st$3);
      var jstfText = argLabels.join(" ") + ": " + applRes.asrtLabel;
      var st$4 = updateStmt(match$1[0], match$1[1], (function (stmt) {
              return {
                      id: stmt.id,
                      label: mainStmtLabel,
                      labelEditMode: stmt.labelEditMode,
                      typ: "p",
                      typEditMode: stmt.typEditMode,
                      cont: {
                        TAG: /* Text */0,
                        _0: MM_parser.getSpaceSeparatedValuesAsArray(asrtExprText)
                      },
                      contEditMode: false,
                      jstfText: jstfText,
                      jstfEditMode: stmt.jstfEditMode,
                      stmtErr: stmt.stmtErr,
                      expr: stmt.expr,
                      jstf: stmt.jstf,
                      proof: stmt.proof,
                      proofStatus: stmt.proofStatus
                    };
            }));
      if (selectionWasEmpty) {
        return uncheckAllStmts(st$4);
      } else {
        return st$4;
      }
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot find assertion with label '" + applRes.asrtLabel + "'."
          },
          Error: new Error()
        };
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot add assertion search result without wrkCtx."
        },
        Error: new Error()
      };
}

function verifyTypesForSubstitution(settings, ctx, frms, wrkSubs) {
  var typesToProve = Belt_MapInt.toArray(wrkSubs).map(function (param) {
        return [MM_context.getTypeOfVarExn(ctx, param[0])].concat(param[1]);
      });
  var proofTree = MM_proof_tree.proofTreeProve(ctx, frms, typesToProve.map(function (typeExpr, i) {
            return {
                    label: undefined,
                    expr: typeExpr,
                    justification: undefined
                  };
          }), MM_parenCounter.parenCntMake(MM_wrk_ctx.prepareParenInts(ctx, settings.parens)), true, undefined, undefined, undefined);
  return typesToProve.every(function (typeExpr) {
              var node = Belt_MutableMap.get(proofTree.rootNodes, typeExpr);
              if (node !== undefined) {
                return Belt_Option.isSome(node.proof);
              }
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "Unexpected condition met: the proofTree was expected to contain nodes for each typeExpr."
                    },
                    Error: new Error()
                  };
            });
}

function convertSubsToWrkSubs(subs, frame, ctx) {
  var frameVarToCtxVar = function (frameVar) {
    var ctxSym = Belt_MapInt.get(frame.frameVarToSymb, frameVar);
    if (ctxSym !== undefined) {
      return MM_context.ctxSymToIntExn(ctx, ctxSym);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot convert frameVar to ctxVar."
          },
          Error: new Error()
        };
  };
  var res = Belt_MutableMapInt.fromArray(Belt_Array.range(1, frame.numOfVars).map(function (v) {
            return [
                    frameVarToCtxVar(v - 1 | 0),
                    MM_substitution.applySubs([v - 1 | 0], subs, (function (param) {
                            throw {
                                  RE_EXN_ID: MM_parser.MmException,
                                  _1: {
                                    msg: "Work variables are not supported in convertSubsToWrkSubs()."
                                  },
                                  Error: new Error()
                                };
                          }))
                  ];
          }));
  var maxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
  for(var v = 0; v <= maxVar; ++v){
    if (!Belt_MutableMapInt.has(res, v)) {
      Belt_MutableMapInt.set(res, v, [v]);
    }
    
  }
  return Belt_MapInt.fromArray(Belt_MutableMapInt.toArray(res));
}

function verifyDisjoints(wrkSubs, disj) {
  var varToSubVars = Belt_MutableMapInt.make(undefined);
  var getSubVars = function ($$var) {
    var arr = Belt_MutableMapInt.get(varToSubVars, $$var);
    if (arr !== undefined) {
      return arr;
    }
    var expr = Belt_MapInt.get(wrkSubs, $$var);
    Belt_MutableMapInt.set(varToSubVars, $$var, expr !== undefined ? expr.filter(function (s) {
                return s >= 0;
              }) : []);
    return Belt_MutableMapInt.getExn(varToSubVars, $$var);
  };
  var res = {
    contents: true
  };
  MM_context.disjForEach(disj, (function (n, m) {
          if (res.contents) {
            getSubVars(n).forEach(function (nv) {
                  if (res.contents) {
                    getSubVars(m).forEach(function (mv) {
                          if (res.contents) {
                            res.contents = nv !== mv && MM_context.disjContains(disj, nv, mv);
                            return ;
                          }
                          
                        });
                    return ;
                  }
                  
                });
            return ;
          }
          
        }));
  return res.contents;
}

function findPossibleSubs(st, frmExpr, expr) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var axLabel = Caml_array.get(MM_context.generateNewLabels(wrkCtx$1, "temp-ax-", 1), 0);
    var frame = MM_context.createFrame(wrkCtx$1, axLabel, MM_context.ctxIntsToSymsExn(wrkCtx$1, frmExpr), true, true, undefined);
    var frm = MM_substitution.prepareFrmSubsDataForFrame(frame);
    var disj = MM_context.getAllDisj(wrkCtx$1);
    var foundSubs = [];
    MM_substitution.iterateSubstitutions(frame.asrt, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, MM_parenCounter.parenCntMake(MM_wrk_ctx.prepareParenInts(wrkCtx$1, st.settings.parens)), (function (subs) {
            var wrkSubs = convertSubsToWrkSubs(subs, frame, wrkCtx$1);
            if (verifyDisjoints(wrkSubs, disj) && verifyTypesForSubstitution(st.settings, wrkCtx$1, st.frms, wrkSubs)) {
              foundSubs.push(wrkSubs);
            }
            return /* Continue */0;
          }));
    return foundSubs;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot search for substitutions without wrkCtx."
        },
        Error: new Error()
      };
}

function applyWrkSubs(expr, subs) {
  var resultSize = {
    contents: 0
  };
  expr.forEach(function (s) {
        if (s < 0) {
          resultSize.contents = resultSize.contents + 1 | 0;
          return ;
        }
        var expr = Belt_MapInt.get(subs, s);
        if (expr !== undefined) {
          resultSize.contents = resultSize.contents + expr.length | 0;
          return ;
        }
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Cannot find a substitution for " + String(s) + " in applyWrkSubs."
              },
              Error: new Error()
            };
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = Caml_array.get(expr, e);
    if (s < 0) {
      Caml_array.set(res, r, s);
      r = r + 1 | 0;
    } else {
      var subExpr = Belt_MapInt.getExn(subs, s);
      var len = subExpr.length;
      Expln_utils_common.copySubArray(subExpr, 0, res, r, len);
      r = r + len | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function applySubstitutionForEditor(st, subs) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    return {
            settingsV: st.settingsV,
            settings: st.settings,
            preCtxV: st.preCtxV,
            preCtx: st.preCtx,
            frms: st.frms,
            varsText: st.varsText,
            varsEditMode: st.varsEditMode,
            varsErr: st.varsErr,
            disjText: st.disjText,
            disjEditMode: st.disjEditMode,
            disjErr: st.disjErr,
            disj: st.disj,
            wrkCtx: st.wrkCtx,
            nextStmtId: st.nextStmtId,
            stmts: st.stmts.map(function (stmt) {
                  var expr = MM_context.ctxSymsToIntsExn(wrkCtx$1, contToArrStr(stmt.cont));
                  var newExpr = applyWrkSubs(expr, subs);
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: {
                            TAG: /* Text */0,
                            _0: MM_context.ctxIntsToSymsExn(wrkCtx$1, newExpr)
                          },
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus
                        };
                }),
            checkedStmtIds: st.checkedStmtIds
          };
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot apply substitution without wrkCtx."
        },
        Error: new Error()
      };
}

function removeUnusedVars(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var usedSymbols = Belt_SetString.fromArray(Expln_utils_common.arrFlatMap(st.stmts, (function (stmt) {
                return contToArrStr(stmt.cont);
              })));
    var unusedVars = MM_context.getLocalVars(wrkCtx$1).filter(function ($$var) {
          return !Belt_SetString.has(usedSymbols, $$var);
        });
    if (unusedVars.length === 0) {
      return st;
    }
    var unusedVarInts = MM_context.ctxSymsToIntsExn(wrkCtx$1, unusedVars);
    var usedVarsStr = MM_context.getLocalHyps(wrkCtx$1).filter(function (hyp) {
              if (hyp.typ === /* F */0) {
                return !unusedVarInts.includes(Caml_array.get(hyp.expr, 1));
              } else {
                return false;
              }
            }).map(function (hyp) {
            return "" + hyp.label + " " + MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 0)) + " " + MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 1)) + "";
          }).join("\n");
    var st$1 = completeVarsEditMode(st, usedVarsStr);
    var newDisj = MM_context.disjMutableMake(undefined);
    MM_context.disjForEach(MM_context.getAllDisj(wrkCtx$1), (function (n, m) {
            if (!unusedVarInts.includes(n) && !unusedVarInts.includes(m)) {
              return MM_context.disjAddPair(newDisj, n, m);
            }
            
          }));
    var newDisjStrArr = [];
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            newDisjStrArr.push(MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts).join(","));
          }));
    return prepareEditorForUnification(completeDisjEditMode(st$1, newDisjStrArr.join("\n")));
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot remove unused variables without wrkCtx."
        },
        Error: new Error()
      };
}

function exprSrcToJstf(wrkCtx, exprSrc) {
  if (typeof exprSrc === "number") {
    return ;
  }
  if (exprSrc.TAG === /* Hypothesis */0) {
    return ;
  }
  var asrtLabel = exprSrc.label;
  var args = exprSrc.args;
  var frame = MM_context.getFrame(wrkCtx, asrtLabel);
  if (frame === undefined) {
    return ;
  }
  var argLabels = [];
  var argLabelsValid = {
    contents: true
  };
  frame.hyps.forEach(function (hyp, i) {
        if (hyp.typ !== /* E */1) {
          return ;
        }
        var argNode = Belt_Array.get(args, i);
        if (argNode === undefined) {
          argLabelsValid.contents = false;
          return ;
        }
        var argLabel = argNode.label;
        if (argLabel !== undefined) {
          argLabels.push(argLabel);
        } else {
          argLabelsValid.contents = false;
        }
      });
  if (argLabelsValid.contents) {
    return {
            args: argLabels,
            asrt: asrtLabel
          };
  }
  
}

function userStmtSetJstfTextAndProof(stmt, wrkCtx, proofNode) {
  var proofSrc = proofNode.proof;
  if (proofSrc === undefined) {
    return stmt;
  }
  var jstfFromProof = exprSrcToJstf(wrkCtx, proofSrc);
  if (jstfFromProof === undefined) {
    return stmt;
  }
  var existingJstf = stmt.jstf;
  if (existingJstf !== undefined) {
    if (Caml_obj.equal(jstfFromProof, existingJstf)) {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: stmt.cont,
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: stmt.stmtErr,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proof: proofNode,
              proofStatus: stmt.proofStatus
            };
    } else {
      return stmt;
    }
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: jstfFromProof.args.join(" ") + " : " + jstfFromProof.asrt,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: stmt.expr,
            jstf: stmt.jstf,
            proof: proofNode,
            proofStatus: stmt.proofStatus
          };
  }
}

function applyUnifyAllResults(st, proofTreeDto) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var nodes = Belt_MutableMap.fromArray(proofTreeDto.nodes.map(function (node) {
              return [
                      node.expr,
                      node
                    ];
            }), MM_context.ExprCmp);
    return st.stmts.reduce((function (st, stmt) {
                  var stmt_id = stmt.id;
                  var stmt_label = stmt.label;
                  var stmt_labelEditMode = stmt.labelEditMode;
                  var stmt_typ = stmt.typ;
                  var stmt_typEditMode = stmt.typEditMode;
                  var stmt_cont = stmt.cont;
                  var stmt_contEditMode = stmt.contEditMode;
                  var stmt_jstfText = stmt.jstfText;
                  var stmt_jstfEditMode = stmt.jstfEditMode;
                  var stmt_stmtErr = stmt.stmtErr;
                  var stmt_expr = stmt.expr;
                  var stmt_jstf = stmt.jstf;
                  if (stmt_typ === "p") {
                    return updateStmt(st, stmt_id, (function (stmt) {
                                  var expr = stmt.expr;
                                  if (expr === undefined) {
                                    return stmt;
                                  }
                                  var node = Belt_MutableMap.get(nodes, expr);
                                  if (node === undefined) {
                                    return stmt;
                                  }
                                  var stmt$1 = userStmtSetJstfTextAndProof(stmt, wrkCtx$1, node);
                                  var match = stmt$1.proof;
                                  if (match !== undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "ready"
                                          };
                                  }
                                  var jstf = stmt$1.jstf;
                                  if (jstf === undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "noJstf"
                                          };
                                  }
                                  var parents = node.parents;
                                  if (parents === undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "jstfIsIncorrect"
                                          };
                                  }
                                  var match$1 = parents.find(function (__x) {
                                        var parentJstf = exprSrcToJstf(wrkCtx$1, __x);
                                        if (parentJstf !== undefined) {
                                          return Caml_obj.equal(parentJstf, jstf);
                                        } else {
                                          return false;
                                        }
                                      });
                                  if (match$1 !== undefined) {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "waiting"
                                          };
                                  } else {
                                    return {
                                            id: stmt$1.id,
                                            label: stmt$1.label,
                                            labelEditMode: stmt$1.labelEditMode,
                                            typ: stmt$1.typ,
                                            typEditMode: stmt$1.typEditMode,
                                            cont: stmt$1.cont,
                                            contEditMode: stmt$1.contEditMode,
                                            jstfText: stmt$1.jstfText,
                                            jstfEditMode: stmt$1.jstfEditMode,
                                            stmtErr: stmt$1.stmtErr,
                                            expr: stmt$1.expr,
                                            jstf: stmt$1.jstf,
                                            proof: stmt$1.proof,
                                            proofStatus: "jstfIsIncorrect"
                                          };
                                  }
                                }));
                  } else {
                    return st;
                  }
                }), st);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot applyUnifyAllResults without wrkCtx."
        },
        Error: new Error()
      };
}

exports.contIsEmpty = contIsEmpty;
exports.contToArrStr = contToArrStr;
exports.contToStr = contToStr;
exports.strToCont = strToCont;
exports.userStmtTypeFromStr = userStmtTypeFromStr;
exports.createEmptyUserStmt = createEmptyUserStmt;
exports.updateStmt = updateStmt;
exports.isStmtChecked = isStmtChecked;
exports.toggleStmtChecked = toggleStmtChecked;
exports.checkAllStmts = checkAllStmts;
exports.uncheckAllStmts = uncheckAllStmts;
exports.deleteCheckedStmts = deleteCheckedStmts;
exports.canMoveCheckedStmts = canMoveCheckedStmts;
exports.moveCheckedStmts = moveCheckedStmts;
exports.addNewStmt = addNewStmt;
exports.isSingleStmtChecked = isSingleStmtChecked;
exports.duplicateCheckedStmt = duplicateCheckedStmt;
exports.canGoEditModeForStmt = canGoEditModeForStmt;
exports.setVarsEditMode = setVarsEditMode;
exports.completeVarsEditMode = completeVarsEditMode;
exports.setDisjEditMode = setDisjEditMode;
exports.completeDisjEditMode = completeDisjEditMode;
exports.setLabelEditMode = setLabelEditMode;
exports.completeLabelEditMode = completeLabelEditMode;
exports.setContEditMode = setContEditMode;
exports.completeContEditMode = completeContEditMode;
exports.setTypEditMode = setTypEditMode;
exports.completeTypEditMode = completeTypEditMode;
exports.setJstfEditMode = setJstfEditMode;
exports.completeJstfEditMode = completeJstfEditMode;
exports.setSettings = setSettings;
exports.setPreCtx = setPreCtx;
exports.editorStateHasErrors = editorStateHasErrors;
exports.refreshWrkCtx = refreshWrkCtx;
exports.prepareProvablesForUnification = prepareProvablesForUnification;
exports.prepareEditorForUnification = prepareEditorForUnification;
exports.addAsrtSearchResult = addAsrtSearchResult;
exports.findPossibleSubs = findPossibleSubs;
exports.applySubstitutionForEditor = applySubstitutionForEditor;
exports.removeUnusedVars = removeUnusedVars;
exports.applyUnifyAllResults = applyUnifyAllResults;
/* MM_context Not a pure module */
